import "./scripts/carousel";

import "./styles/carousel.scss";
import "./styles/featurettes.scss";
import "./styles/blocks.scss";
import "./styles/home.scss";
